import ItemDatePicker from "@/modules/front/ItemDatePicker";
import React, {useState} from "react";
import {useForm} from "react-hook-form";
import {Button, Form} from "react-bootstrap";

const TYPE_CHECKBOX = "checkbox";
const TYPE_TEXTINPUT = "textinpupt";
const TYPE_TEXT = "text";
const TYPE_SELECT = "select";

const ReservationExternalStep1 = ({personalData, pricingNote, customFields = [], addressRequired = false, ...props}) => {
    const {
        register,
        handleSubmit,
        formState: {errors},

    } = useForm({
        defaultValues: personalData
    });

    const [isCompanyReservation, setIsCompanyReservation] = useState(false);

    const handleCompanyCheckboxChange = (e) => {
        setIsCompanyReservation(e.target.checked);
    };

    const onSubmit = (data) => {
        if (!isCompanyReservation) {
            data.company_name = null;
            data.company_id = null;
            data.company_vat_id = null;
            data.company_address = null;
            data.company_city = null;
            data.company_zip = null;
        }
        const customValues = {};
        (customFields || []).forEach(f => {
            const key = 'custom_' + f.id;
            if (data[key] !== undefined) {
                customValues[key] = f.type === TYPE_CHECKBOX ? (data[key] ? 'ano' : 'ne') : data[key];
            }
        });
        data.customValues = customValues;
        props.onPersonalDataSubmitted(data);
    };

    let submitBtn = <div onClick={() => {
        props.onError('Pro pokračování vyberte volný termín v kalendáři.')
    }}><Button
        className={'btn btn-primary px-4 py-2 rounded-0 disabled'}

    >{window.translations.reservationExternal.next} <i className="fas fa-chevron-right ms-3"></i></Button></div>;
    if (props.dateFrom && props.dateTo) {
        submitBtn = <Button className={'btn btn-primary px-4 py-2 rounded-0'} type="submit" variant="primary">
            {window.translations.reservationExternal.next} <i className="fas fa-chevron-right ms-3"></i>
        </Button>
    }

    return <div>
        <div className={'text-center'}>
            <ItemDatePicker
                locale={props.locale}
                offices={props.offices}
                office={props.office}
                lockOffice={props.lockOffice}
                onDateConfirmed={props.onDateConfirmed}
                addToCartLabel={false}
                itemId={props.itemId}
                calendarMonths={props.calendarMonths}
                weekendRentalNotice={props.weekendRentalNotice}
            />
        </div>
        {pricingNote &&
        <div className={'text-end small text-black mb-3 me-2 mt-2 me-2'}>
            {pricingNote}
        </div>}
        <form className={'mt-4'} onSubmit={handleSubmit(onSubmit)}>
            <div className={'row'}>
                <div className={'col-6'}>
                    <Form.Group className="mb-2" controlId="firstname">
                        <Form.Label>{window.translations.personalInfo.firstName}</Form.Label>
                        <Form.Control
                            type="text"
                            {...register("firstname", {
                                required: "Zadejte prosím vaše jméno.",
                            })}
                        />
                        {errors.firstname && <p className="text-danger">{errors.firstname.message}</p>}
                    </Form.Group>
                </div>
                <div className={'col-6'}>
                    <Form.Group className="mb-2" controlId="lastname">
                        <Form.Label>{window.translations.personalInfo.lastName}</Form.Label>
                        <Form.Control
                            type="text"
                            {...register("lastname", {
                                required: "Zadejte prosím vaše příjmení.",
                            })}
                        />
                        {errors.lastname && <p className="text-danger">{errors.lastname.message}</p>}
                    </Form.Group>
                </div>
            </div>
            <div className={'row'}>
                <div className={'col-sm-6'}>
                    <Form.Group className="mb-3" controlId="email">
                        <Form.Label>{window.translations.personalInfo.email}</Form.Label>
                        <Form.Control
                            type="email"
                            {...register("email", {
                                required: "Zadejte prosím váš e-mail",
                                pattern: {
                                    value: /^[^@ ]+@[^@ ]+\.[^@ .]{2,}$/,
                                    message: "Zadaná e-mailová adresa není platná."
                                }
                            })}
                        />
                        {errors.email && <p className="text-danger">{errors.email.message}</p>}
                    </Form.Group>
                </div>
                <div className={'col-sm-6'}>
                    <Form.Group className="mb-3" controlId="phone">
                        <Form.Label>{window.translations.personalInfo.phone}</Form.Label>
                        <Form.Control
                            type="text"
                            {...register("phone", {
                                required: "Zadejte prosím váš telefon."
                            })}
                        />
                        {errors.phone && <p className="text-danger">{errors.phone.message}</p>}
                    </Form.Group>
                </div>
            </div>
            <div className={'row'}>
                <div className={'col-12'}>
                    <Form.Group className="mb-3" controlId="address">
                        <Form.Label>{window.translations.personalInfo.address}{addressRequired ? ' *' : ''}</Form.Label>
                        <Form.Control
                            type="text"
                            {...register("address", {
                                required: addressRequired ? window.translations.personalInfo.addressRequired : false,
                            })}
                        />
                        {errors.address && <p className="text-danger">{errors.address.message}</p>}
                    </Form.Group>
                </div>
            </div>
            <div className={'row'}>
                <div className={'col-6'}>
                    <Form.Group className="mb-3" controlId="city">
                        <Form.Label>{window.translations.personalInfo.city}{addressRequired ? ' *' : ''}</Form.Label>
                        <Form.Control
                            type="text"
                            {...register("city", {
                                required: addressRequired ? window.translations.personalInfo.cityRequired : false
                            })}
                        />
                        {errors.city && <p className="text-danger">{errors.city.message}</p>}
                    </Form.Group>
                </div>
                <div className={'col-6'}>
                    <Form.Group className="mb-3" controlId="zip">
                        <Form.Label>{window.translations.personalInfo.zip}{addressRequired ? ' *' : ''}</Form.Label>
                        <Form.Control
                            type="text"
                            {...register("zip", {
                                required: addressRequired ? window.translations.personalInfo.zipRequired : false
                            })}
                        />
                        {errors.zip && <p className="text-danger">{errors.zip.message}</p>}
                    </Form.Group>
                </div>
            </div>

            {/* Company Reservation Section */}
            <div className={"mb-3"}>
                <Form.Check
                    type="checkbox"
                    id="companyReservation"
                    label={window.translations.personalInfo.isCompany}
                    {...register("isCompanyReservation")}
                    onChange={handleCompanyCheckboxChange}
                />
            </div>

            {isCompanyReservation && (
                <div className={"row"}>
                    <div className={"col-sm-6"}>
                        <Form.Group className="mb-3" controlId="company_name">
                            <Form.Label>{window.translations.personalInfo.companyName}</Form.Label>
                            <Form.Control
                                type="text"
                                {...register("company_name", {
                                    required: "Zadejte prosím název firmy.",
                                })}
                            />
                            {errors.company_name && <p className="text-danger">{errors.company_name.message}</p>}
                        </Form.Group>
                    </div>
                    <div className={"col-sm-3"}>
                        <Form.Group className="mb-3" controlId="company_id">
                            <Form.Label>{window.translations.personalInfo.companyId}</Form.Label>
                            <Form.Control
                                type="text"
                                {...register("company_id", {
                                    required: "Zadejte prosím IČO firmy.",
                                })}
                            />
                            {errors.company_id && <p className="text-danger">{errors.company_id.message}</p>}
                        </Form.Group>
                    </div>
                    <div className={"col-sm-3"}>
                        <Form.Group className="mb-3" controlId="company_vat_id">
                            <Form.Label>{window.translations.personalInfo.companyVatId}</Form.Label>
                            <Form.Control
                                type="text"
                                {...register("company_vat_id", {
                                })}
                            />
                            {errors.company_vat_id && <p className="text-danger">{errors.company_vat_id.message}</p>}
                        </Form.Group>
                    </div>
                    <div className={"col-sm-6"}>
                        <Form.Group className="mb-3" controlId="company_address">
                            <Form.Label>{window.translations.personalInfo.companyAddress}</Form.Label>
                            <Form.Control
                                type="text"
                                {...register("company_address")}
                            />
                            {errors.company_address && <p className="text-danger">{errors.company_address.message}</p>}
                        </Form.Group>
                    </div>
                    <div className={"col-sm-3"}>
                        <Form.Group className="mb-3" controlId="company_city">
                            <Form.Label>{window.translations.personalInfo.companyCity}</Form.Label>
                            <Form.Control
                                type="text"
                                {...register("company_city")}
                            />
                            {errors.company_city && <p className="text-danger">{errors.company_city.message}</p>}
                        </Form.Group>
                    </div>
                    <div className={"col-sm-3"}>
                        <Form.Group className="mb-3" controlId="company_zip">
                            <Form.Label>{window.translations.personalInfo.companyZip}</Form.Label>
                            <Form.Control
                                type="text"
                                {...register("company_zip")}
                            />
                            {errors.company_zip && <p className="text-danger">{errors.company_zip.message}</p>}
                        </Form.Group>
                    </div>
                </div>
            )}

            {(customFields || []).length > 0 && (
                <div className="row mb-3">
                    {(customFields || []).map(field => (
                        <div key={field.id} className={field.col_size || 'col-12'}>
                            <Form.Group className="mb-3" controlId={'custom_' + field.id}>
                                {field.type === TYPE_CHECKBOX ? (
                                    <Form.Check
                                        type="checkbox"
                                        id={'custom_' + field.id}
                                        label={field.label + (field.required ? ' *' : '')}
                                        {...register('custom_' + field.id, {
                                            required: field.required ? "Toto pole je povinné." : false
                                        })}
                                    />
                                ) : (
                                    <>
                                        <Form.Label>{field.label}{field.required ? ' *' : ''}</Form.Label>
                                        {field.type === TYPE_TEXTINPUT && (
                                            <Form.Control
                                                type="text"
                                                {...register('custom_' + field.id, {
                                                    required: field.required ? "Toto pole je povinné." : false
                                                })}
                                            />
                                        )}
                                        {field.type === TYPE_TEXT && (
                                            <Form.Control
                                                as="textarea"
                                                rows={2}
                                                {...register('custom_' + field.id, {
                                                    required: field.required ? "Toto pole je povinné." : false
                                                })}
                                            />
                                        )}
                                        {field.type === TYPE_SELECT && (
                                            <Form.Select
                                                {...register('custom_' + field.id, {
                                                    required: field.required ? "Toto pole je povinné." : false
                                                })}
                                            >
                                                <option value="">-- vyberte --</option>
                                                {(field.options || []).map((opt, idx) => (
                                                    <option key={idx} value={opt}>{opt}</option>
                                                ))}
                                            </Form.Select>
                                        )}
                                    </>
                                )}
                                {errors['custom_' + field.id] && <p className="text-danger">{errors['custom_' + field.id].message}</p>}
                            </Form.Group>
                        </div>
                    ))}
                </div>
            )}

            <div className={'text-end'}>
                {submitBtn}
            </div>
        </form>

    </div>;
};

export default ReservationExternalStep1;